import React from 'react';
import { Link } from 'react-router-dom';
import styles from './OpenHoursSection.module.css';



const HOURS = [
    { label: 'Tuesday — Sunday', time: '12:30 PM — 1:30 AM' },
    { label: 'Monday', time: '6:30 PM — 1:30 AM' },
];

const OpenHoursSection = () => {

    const top1 = '/images/27-DSC09435.jpg';
    const top2 = '/images/19-DSC09397.jpg';
    const top3 = '/images/1-DSC09321.jpg';
    const bottom1 = '/images/22-DSC09424.jpg';
    const bottom2 = '/images/20-DSC09415.jpg';
    const bottom3 = '/images/26-DSC09433.jpg';

    return (
        <section className={styles.sectionContainer}>
            <div className={styles.wrapper}>

                {/* ── Top Staggered Image Grid ── */}
                <div className={styles.imageGridTop}>
                    <div className={styles.imageCard}>
                        <img src={top1} alt="Berli Brewing interior" />
                    </div>
                    <div className={`${styles.imageCard} ${styles.centerImageTop}`}>
                        <img src={top2} alt="Brewer at work" />
                    </div>
                    <div className={styles.imageCard}>
                        <img src={top3} alt="Craft beer pour" />
                    </div>
                </div>

                {/* ── Center Content Block ── */}
                <div className={styles.contentBlock}>
                    <h2 className={styles.heading}>Opening Hours</h2>

                    <div className={styles.hoursList}>
                        {HOURS.map(({ label, time }) => (
                            <p key={label} className={styles.hoursLine}>
                                <span className={styles.label}>{label}:</span> {time}
                            </p>
                        ))}
                    </div>

                    <Link to="/menu" className={styles.menuBtn}>
                        View Menu
                    </Link>

                    <Link to="/reservation" className={styles.bookLink}>
                        Book a Table
                    </Link>
                </div>

                {/* ── Bottom Staggered Image Grid ── */}
                <div className={styles.imageGridBottom}>
                    <div className={styles.imageCard}>
                        <img src={bottom1} alt="Berli food plating" />
                    </div>
                    <div className={`${styles.imageCard} ${styles.centerImageBottom}`}>
                        <img src={bottom2} alt="Berli Brewing exterior" />
                    </div>
                    <div className={styles.imageCard}>
                        <img src={bottom3} alt="Signature dish" />
                    </div>
                </div>

            </div>
        </section>
    );
};

export default OpenHoursSection;